import { CLEAR_SITE_DATA } from '../application';
import {
  RECEIVE_NOTIFICATION,
  HIDE_NOTIFICATION,
  REMOVE_NOTIFICATION,
  REMOVE_NOTIFICATIONS_BY_TYPE,
  MARK_NOTIFICATIONS_READ,
  CLEAR_ALL_NOTIFICATIONS,
  CLEAR_FILTERED_NOTIFICATIONS,
  SET_PANEL_OPENED,
  SET_NOTIFICATION_FILTERS,
  RESET_NOTIFICATION_FILTERS,
  SET_ONLINE,
  SET_OFFLINE,
} from './actions';

const initialState = {
  online: true,
  notifications: {},
  lastOpenedAt: null,
  filters: { sources: [], types: [] },
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_NOTIFICATION: {
      const { notification } = action;

      return {
        ...state,
        notifications: {
          ...state.notifications,
          [notification.id]: notification,
        },
      };
    }
    case HIDE_NOTIFICATION: {
      const { id } = action;

      return {
        ...state,
        notifications: {
          ...state.notifications,
          [id]: {
            ...state.notifications[id],
            visible: false,
          },
        },
      };
    }
    case REMOVE_NOTIFICATION: {
      const { id } = action;
      const notifications = { ...state.notifications };
      delete notifications[id];

      return {
        ...state,
        notifications,
      };
    }
    case REMOVE_NOTIFICATIONS_BY_TYPE: {
      const { notificationType } = action;
      const updatedNotifications = Object.values(state.notifications).reduce((acc, n) => {
        if (n.type !== notificationType) {
          acc[n.id] = n;
        }
        return acc;
      }, {});

      return {
        ...state,
        notifications: updatedNotifications,
      };
    }
    case MARK_NOTIFICATIONS_READ: {
      const updatedNotifications = Object.fromEntries(
        Object.values(state.notifications).map((n) => [n.id, { ...n, read: true }])
      );

      return {
        ...state,
        notifications: updatedNotifications,
      };
    }
    case CLEAR_ALL_NOTIFICATIONS: {
      return {
        ...state,
        notifications: {},
      };
    }
    case CLEAR_FILTERED_NOTIFICATIONS: {
      const {
        filters: { sources, types },
      } = action;
      const updatedNotifications = Object.values(state.notifications).reduce((acc, n) => {
        const unfilteredSource = sources.length === 0;
        const unfilteredType = types.length === 0;
        if (
          (unfilteredSource && unfilteredType) ||
          (unfilteredSource && !unfilteredType && !types.includes(n.status)) ||
          (unfilteredType && !unfilteredSource && !sources.includes(n.category || 'system')) ||
          (!unfilteredSource &&
            !unfilteredType &&
            !(sources.includes(n.category || 'system') && types.includes(n.status)))
        ) {
          acc[n.id] = n;
        }
        return acc;
      }, {});
      return {
        ...state,
        notifications: updatedNotifications,
      };
    }
    case SET_PANEL_OPENED: {
      return {
        ...state,
        lastOpenedAt: Date.now(),
      };
    }
    case SET_NOTIFICATION_FILTERS: {
      return {
        ...state,
        filters: { ...state.filters, ...action.filters },
      };
    }
    case RESET_NOTIFICATION_FILTERS: {
      return {
        ...state,
        filters: { sources: [], types: [] },
      };
    }
    case SET_ONLINE: {
      return {
        ...state,
        online: true,
      };
    }
    case SET_OFFLINE: {
      return {
        ...state,
        online: false,
      };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
